import { css } from '@emotion/css';
import { useProxyProductionImages } from 'Shared/common/ProxyProductionImagesProvider';
import { useUrls } from 'Shared/UrlProvider';


/* 'contain' rather than 'cover' because posters converted from the old builder don't share the
   frame's aspect ratio - cropping them to fill it cuts the poster off. */
const imageStyle = css({
	width: '100%',
	height: '100%',
	objectPosition: 'center',
	objectFit: 'contain'
});


/* Without a rendered image there is nothing to show and the fallback poster has to stand in. */
export function hasRenderedPoster(poster): boolean
{
	return poster?.hash != undefined && poster?.formats?.medium != undefined;
}

/* Only worth showing while the render is both present and up to date. */
export function isCurrentRenderedPoster(poster): boolean
{
	return poster?.isCurrent == true && hasRenderedPoster(poster);
}

/* Takes the poster off the event rather than being handed one, so callers holding a fresher
   render than the document's (see the events list) ask isCurrentRenderedPoster directly. */
export function hasCurrentRenderedPoster(event): boolean
{
	return isCurrentRenderedPoster(event.posterNEW);
}

export function EventPosterImage(P:{event})
{
	const poster = () => P.event.posterNEW;

	const url = () => useUrls().createVenueImageUrl(
		poster().hash, poster(), 'Event-poster', 'medium', useProxyProductionImages());

	return (
		<img class={imageStyle} src={url()} loading='lazy' alt='' />
	);
}
